import { Box, Heading, Text } from '@chakra-ui/react';
import type { SyncFolderConfig } from '~/common/types/SyncFolderConfig';
import { ResyncFolderButton } from '~/common/components/ResyncFolderButton';

export interface DocumentNotFoundStateProps {
  compact?: boolean;
  alignTop?: boolean;
  syncFolderConfig?: SyncFolderConfig;
}

export const DocumentNotFoundState: React.FC<DocumentNotFoundStateProps> = ({
  compact,
  alignTop,
  syncFolderConfig: { canSyncFolder, onSyncFolder, isSyncingFolder } = {},
}) => {
  return (
    <Box
      alignItems={alignTop ? 'flex-start' : 'center'}
      bg="transparent"
      display="flex"
      h="full"
      justifyContent="center"
      p={6}
    >
      <Box
        bg="compliance.card.bg"
        borderColor="compliance.card.border"
        borderRadius="md"
        borderWidth="1px"
        maxW={compact ? 'sm' : 'lg'}
        p={6}
        textAlign="center"
        w="full"
      >
        <Heading as="h3" color="compliance.text.primary" fontSize="lg" mb={2}>
          Couldn't find document information.
        </Heading>
        <Text color="compliance.text.secondary" mb={4}>
          We couldn't load this document. It may have been removed or isn't
          available yet. You can try again shortly or contact us.
        </Text>
        {canSyncFolder && onSyncFolder && (
          <ResyncFolderButton
            isSyncing={isSyncingFolder}
            onSyncFolder={onSyncFolder}
          />
        )}
      </Box>
    </Box>
  );
};
